(() => {
  const preloader = document.querySelector('.preloader');
  if (!preloader) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    preloader.remove();
    return;
  }

  const logo = preloader.querySelector('.preloader__logo');
  const left = preloader.querySelector('.preloader__half--left');
  const right = preloader.querySelector('.preloader__half--right');

  const easeBack = 'cubic-bezier(0.34, 1.56, 0.64, 1)';
  const easeInOut = 'cubic-bezier(0.85, 0, 0.15, 1)';
  const easeIn = 'cubic-bezier(0.55, 0.06, 0.68, 0.19)';

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const play = (el, keyframes, options) => el.animate(keyframes, options).finished;

  const BASE = { transform: 'translate(-50%, -50%)' };

  (async () => {
    document.body.classList.add('no-scroll');

    if (logo) {
      await play(
        logo,
        [
          { transform: 'translate(-50%, -50%) scale(0)', opacity: 0 },
          { transform: 'translate(-50%, -50%) scale(1)', opacity: 1 }
        ],
        { duration: 250, easing: easeBack, fill: 'both' }
      );

      for (let i = 0; i < 2; i += 1) {
        await play(
          logo,
          [
            { ...BASE, scale: '1' },
            { ...BASE, scale: '1.15' },
            { ...BASE, scale: '1' }
          ],
          { duration: 200, fill: 'both', easing: 'ease-in-out' }
        );
      }

      await play(
        logo,
        [
          { transform: 'translate(-50%, -50%) scale(1)', opacity: 1 },
          { transform: 'translate(-50%, -50%) scale(0.6)', opacity: 0 }
        ],
        { duration: 200, easing: easeIn, fill: 'both' }
      );
    }

    await Promise.all([
      left
        ? play(left, [{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }], {
            duration: 400,
            easing: easeInOut,
            fill: 'both'
          })
        : Promise.resolve(),
      right
        ? play(right, [{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }], {
            duration: 400,
            easing: easeInOut,
            fill: 'both'
          })
        : Promise.resolve()
    ]);

    preloader.classList.add('is-done');
    document.body.classList.remove('no-scroll');
    if (typeof ScrollTrigger !== 'undefined') {
      requestAnimationFrame(() => ScrollTrigger.refresh());
    }
    await sleep(200);
    preloader.remove();
  })();
})();
